import { useCallback } from 'react';
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { FirebaseOptions } from 'firebase/app';

import { FirestoreDb } from '@gif/shared-global';
import { setFirestoreDb } from '../slices';

interface UseFireBaseArgs {
  useAppSelector: any;
  useAppDispatch: any;
  firebaseConfig: {
    firebaseOptions: FirebaseOptions;
    firebaseDbId: string;
  };
}
export const useFirebase = ({
  useAppDispatch,
  useAppSelector,
  firebaseConfig,
}: UseFireBaseArgs) => {
  const firestoreDb = useAppSelector((state: FirestoreDb) => state.db);
  const dispatch = useAppDispatch();

  const initializeFirestore = useCallback(() => {
    initializeApp(firebaseConfig.firebaseOptions);
    const db = getFirestore(firebaseConfig.firebaseDbId);
    dispatch(setFirestoreDb(db));
  }, [dispatch, firebaseConfig.firebaseDbId, firebaseConfig.firebaseOptions]);

  return {
    initializeFirestore,
    firestoreDb,
  };
};

export default useFirebase;
